<div *ngIf="routerAccess">
    <button (click)="back()" kendoButton><i class="k-icon k-i-arrow-chevron-left"></i> Back</button>
 </div>
 <div class="k-overlay" *ngIf="opened"></div>
 <kendo-window [title]="ModalTitle" *ngIf="opened" (close)="close()" [@fadeInOnEnter]>
    <div class="row">
       <div *ngIf="isNewMode" class="col-md-12">
          <app-information-box [infoLines]="['Search and select an asset. Then complete the return to supplier information']"></app-information-box>
       </div>
       <div *ngIf="isNewMode" class="col-md-6">
          <app-asset-selection [method]="'ALL'" (assetSelected)="assetSelected($event)"></app-asset-selection>
       </div>
       <div [ngClass]="{ 'col-md-6': isNewMode, 'col-md-12': !isNewMode }">
          <mdb-card cascade="true" narrower="true">
             <div class="special-color text-white d-flex justify-content-center p-3">
                <h5><i class="fa fa-recycle mr-1"></i>Return to Supplier Info</h5>
             </div>
             <form class="k-form p-3" [formGroup]="disposalForm" (ngSubmit)="save()" [appHasRoleDisable]="['SYSTEM-ADMIN', 'DISP-CR', 'DISP-ED']">
                <div class="row">
                   <div class="col-md-12">
                      <div>
                         <kendo-floatinglabel text="Barcode *" class="w-100">
                            <input kendoTextBox id="barcodeEdit" name="barcode" formControlName="barcode" class="w-100" />
                         </kendo-floatinglabel>
                         <div
                            class="red-text error-text"
                            *ngIf="disposalForm.controls['barcode'].hasError('required') && (disposalForm.controls['barcode'].dirty || disposalForm.controls['barcode'].touched)"
                         >
                            Barcode required
                         </div>
                         <div class="red-text error-text" *ngIf="disposalForm.controls['barcode'].hasError('maxlength')">Max Length of 50 allowed</div>
                      </div>



                      <div>
                        <kendo-floatinglabel text="Supplier" class="w-100">
                           <input 
                            kendoTextBox 
                            name="method" 
                            class="w-100" 
                            [(ngModel)]="supplierName"
                            [ngModelOptions]="{ standalone: true }"
                            [disabled]="true"
                           />
                        </kendo-floatinglabel>
                     </div>
                     <div>
                        <kendo-floatinglabel text="Original Invoice No" class="w-100">
                           <input 
                            kendoTextBox 
                            name="method" 
                            class="w-100" 
                            [(ngModel)]="invoiceNumber"
                            [ngModelOptions]="{ standalone: true }"
                            [disabled]="true"
                           />
                        </kendo-floatinglabel>
                     </div>
                     <div>
                        <kendo-floatinglabel text="Acquisition Date" class="w-100">
                           <kendo-datepicker [format]="'dd-MMM-yyyy'" [disabled]="true" [(ngModel)]="acquisitionDate" [ngModelOptions]="{ standalone: true }"></kendo-datepicker>
                        </kendo-floatinglabel>
                     </div>
                      <div>
                         <kendo-floatinglabel text="Return Date *" class="w-100">
                            <kendo-datepicker [format]="'dd-MMM-yyyy'" formControlName="disposalDate"></kendo-datepicker>
                         </kendo-floatinglabel>
                         <div
                            class="red-text error-text"
                            *ngIf="
                               disposalForm.controls['disposalDate'].hasError('required') &&
                               (disposalForm.controls['disposalDate'].dirty || disposalForm.controls['disposalDate'].touched)
                            "
                         >
                            Disposal Date Required
                         </div>
                      </div>

                      <div>
                         <kendo-floatinglabel text="Credit Note No" class="w-100">
                            <input kendoTextBox id="CreditNoteNoEdit" name="creditNoteNo" formControlName="creditNoteNo" class="w-100" />
                         </kendo-floatinglabel>
                         <div class="red-text error-text" *ngIf="disposalForm.controls['creditNoteNo'].hasError('maxlength')">Max Length of 50 allowed</div>
                      </div>

                      <div>
                         <kendo-floatinglabel text="Return Reason *" class="w-100">
                            <input kendoTextBox id="ReasonEdit" name="reason" formControlName="reason" class="w-100" />
                         </kendo-floatinglabel>
                         <div class="red-text error-text" *ngIf="disposalForm.controls['reason'].hasError('maxlength')">Max Length of 50 allowed</div>
                         <div
                            class="red-text error-text"
                            *ngIf="disposalForm.controls['reason'].hasError('required') && (disposalForm.controls['reason'].dirty || disposalForm.controls['reason'].touched)"
                            >
                            Return Reason required
                      </div>
                      </div>
                   </div>
                </div>
 
                <div class="modal-footer d-flex justify-content-center">
                   <div *appHasRole="['SYSTEM-ADMIN', 'DISP-CR', 'DISP-ED']">
                      <button *ngIf="!loading" [disabled]="disposalForm.invalid" look="flat" kendoButton type="submit" icon="save" [primary]="true">Save</button>
                   </div>
                   <div class="red-text" *appHasNotRole="['SYSTEM-ADMIN', 'DISP-CR', 'DISP-ED']">You do not have permission to edit.</div>
                   <mdb-spinner *ngIf="loading" spinnerType="small"></mdb-spinner>
                </div>
             </form>
          </mdb-card>
       </div>
    </div>
 </kendo-window>
 